import { AfterContentChecked, AfterContentInit, AfterViewInit, Component, ContentChildren, EventEmitter, OnInit, Output, QueryList } from '@angular/core';
import { Subscription } from 'rxjs';
import { ExpandItemComponent } from '../expand-item/expand-item.component';

@Component({
  selector: 'app-expand-list',
  templateUrl: './expand-list.component.html',
  styleUrls: ['./expand-list.component.scss'],
})
export class ExpandListComponent implements AfterContentChecked {
  @ContentChildren(ExpandItemComponent) contentChildren: QueryList<ExpandItemComponent>;
  private contentChangeSubscriber: Subscription;
  public loading: boolean;

  @Output() hasOpenItem:EventEmitter<boolean> =  new EventEmitter();
  constructor() { }

  ngOnInit() { }

  reset(){
    if(this.contentChildren){
          this.contentChildren.forEach((child: any,index:number) => {
            child.close(true);
          })
    }
  }
  toggleMatch( matcher:Function,scrollTo?:boolean){
    if(this.contentChildren){
      const match = this.contentChildren.find((child: any,index:number) => {
        const matched = matcher( child );
        return matched;
      })
      if(match){
        match.open();
        if(scrollTo){
          match.expander.nativeElement.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    }
  }
  ngAfterContentChecked() {
    if(this.contentChangeSubscriber) return;
    this.contentChangeSubscriber = this.contentChildren.changes.subscribe((queryList) => {
      if (queryList.length) {
        this.contentChildren.forEach((child: any,index:number) => {
          child.onToggle.subscribe((e: { state: string, instance: ExpandItemComponent }) => {
            const { state, instance } = e;
            if (state == 'opened') {
              this.hasOpenItem.emit(true);
              child.expandable.nativeElement.style.opacity = 1;
              child.expandable.nativeElement.classList.add('active');
              this.contentChildren.forEach((other: any) => {
                if (other !== instance) {
                  other.close(true);
                  other.expandable.nativeElement.style.opacity = 0.5;
                  child.expandable.nativeElement.classList.remove('active');
                }
              })
            } else {
              this.hasOpenItem.emit(false);
              this.contentChildren.forEach((other: any) => {
                other.expandable.nativeElement.style.opacity = 1;
                other.expandable.nativeElement.classList.remove('active');
              });
            }

          });// onToggle


        })// eachchild

        this.contentChangeSubscriber.unsubscribe();
        // setTimeout( ()=>{
        //           this.contentChildren.first.open();
        // },1500)
      }
    })
    this.loading = false;


  }

}
